function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.667 14.167c.184 0 .333.149.333.333v3.833A1.667 1.667 0 0116.333 20H7.667A1.667 1.667 0 016 18.333V14.5c0-.184.15-.333.333-.333zM14.333 15.5H9.667a.5.5 0 100 1h4.666a.5.5 0 100-1zm2-11.5C17.253 4 18 4.746 18 5.667v7.166c0 .184-.15.334-.333.334h-4.834a.333.333 0 01-.333-.334v-8.5c0-.184.15-.333.333-.333zm-5.166 0c.184 0 .333.15.333.333v8.5c0 .184-.15.334-.333.334H6.333A.333.333 0 016 12.833V5.667C6 4.747 6.746 4 7.667 4zm3.166 2.833a.5.5 0 00-.5.5v3.334a.5.5 0 001 0V7.333a.5.5 0 00-.5-.5zm-4.666 0a.5.5 0 00-.5.5v3.334a.5.5 0 101 0V7.333a.5.5 0 00-.5-.5z"
});

function SvgMiniRefrigirator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgMiniRefrigirator;